/**
 * Bridge module — re-exports the raw @dsg-tech/homefield-angular-icons npm package
 * using a relative path so it avoids the @dsg-tech/homefield-angular-icons tsconfig
 * path alias (which points here → circular), while remaining resolvable by both
 * TypeScript and esbuild.
 */
// eslint-disable-next-line @nx/enforce-module-boundaries
export * from '../../../../node_modules/@dsg-tech/homefield-angular-icons';
